<style lang="scss" scoped>
img {
  background-size: cover;
}
</style>

<template>
  <img :style="'background-image: url(' + background + ')'" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7">
</template>
<script>
export default {
  props: ['background']
}
</script>
